import React from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
 
 
const slides = [
  {
    bg: "assets/images/backgrounds/main-slider-v1-img1.png",
    img: "assets/images/backgrounds/main-slider-v1-img3.jpg",
 
    title: (
      <>
        Your Kindness Can <br /> Light Up Lives
      </>
    ),
    text: (
      <>
 
       Join our mission to provide food, shelter, education, healthcare, and hope to those in need. Together, we can empower communities, transform lives, and build a brighter future. Every act of kindness brings hope and creates lasting change.
 
   
 
      </>
    ),
  },
  {
    bg: "assets/images/backgrounds/main-slider-v1-img2.png",
    img: "assets/images/backgrounds/main-slider-v1-img3.jpg",
    title: "Disability and Health Program",
    text: (
      <>
        Vikash provides essential medical treatment, medicines, and care for
        disabled children. They focus on rehabilitation and emotional support,
        helping children lead healthier, more integrated lives.
      </>
    ),
  },
];
 
const MainSlider = () => {
  return (
    <section className="main-slider main-slider-one">
      <Carousel fade controls={false} indicators interval={4000} pause={false}>
        {slides.map((slide, index) => (
          <Carousel.Item key={index}>
            <div
              className="main-slider-one__bg"
              style={{
                backgroundImage: `url(${slide.bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "100vh",
                position: "relative",
              }}
            >
              {/* Overlay */}
              <div className="main-slider-overlay"></div>
 
              {/* Floating Shapes */}
              <div className="shape1 float-bob-y">
                <img
                  src="assets/images/shapes/main-slider-v1-shape1.png"
                  alt=""
                  style={{ filter: 'hue-rotate(90deg)' }} // <-- EXAMPLE FOR ANOTHER SHAPE // <-- ADD THIS STYLE
                />
              </div>
              <div className="shape2">
                <img
                  src="assets/images/shapes/main-slider-v1-shape2.png"
                  alt=""
                  style={{ filter: 'hue-rotate(90deg)', marginBottom: "130px" }} // <-- EXAMPLE FOR ANOTHER SHAPE
 
                 
                />
              </div>
              <div className="shape3 float-bob-x">
                <img
                  src="assets/images/shapes/main-slider-v1-shape3.png"
                  alt=""
                  style={{ filter: 'hue-rotate(90deg)' }} // <-- EXAMPLE FOR ANOTHER SHAPE
                />
              </div>
              <div className="shape4">
                <img
                  src="assets/images/shapes/main-slider-v1-shape4.png"
                  alt=""
                  style={{ filter: 'hue-rotate(90deg)' }} // <-- EXAMPLE FOR ANOTHER SHAPE
                />
              </div>
 
              {/* Foreground Child Image */}
              <div className="main-slider-one__single-img">
                <img src={slide.img} alt="Child" />
              </div>
 
              {/* Text Content */}
              <div className="container ">
                <div className="main-slider-one__content">
                  <div className="main-slider-one__sub-title ">
                    <p>{slide.subtitle}</p>
                  </div>
                  <div className="main-slider-one__title t">
                    <h2>{slide.title}</h2>
                  </div>
                  <div className="main-slider-one__text">
                    <p>{slide.text}</p>
                  </div>
                 
                </div>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </section>
  );
};
 
export default MainSlider;
 
 